import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { IUsers } from "../types";

// TO DO : need to exist in the general data entities and refactored
interface IGetDataProps {
  pagination?: {
    pageSize?: number;
    current?: number;
  };
  token?: string;
  sector?: string | null;
  experience?: string | null;
  gender?: string | null;
}

export const QUERY_KEY_FOR_USERS  = "Users";

const getTalents = async (
  props: IGetDataProps
): Promise<{ data: IUsers[]; total: number }> => {
  const { pagination, sector, experience, gender } = props;

  const url = `${END_POINT.BASE_URL}/v1/administrator/users`;

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
    params: {
      page: pagination?.current,
      limit: pagination?.pageSize,
      sector,
      experience,
      gender,
    },
  };

  const res = await axios.get(url, config);
  const fetchedData = res.data.data;

  const data: IUsers[] = fetchedData.map(
    (item: IUsers): IUsers => ({ ...item })
  );
  const ans = {
    data,
    total: res.data.total,
  };
  
  return ans;
};

export const useFetchUsers = (props: IGetDataProps) => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_USERS, props],
    () =>
      getTalents({
        ...props,
        token,
      }),
    {
      onError: (err: any) => {},
      onSuccess: (data) => {},
    }
  );
  return queryData;
};